<div class="location-warehouse-app pt-6">
  <div [@slideInAnimation] class="flex justify-content-center">
    <button
      class="app-option__button-wrapper"
      routerLink="/warehouse-mobile-app/devices"
    >
      <div class="app-option flex flex-column align-items-center">
        <img
          class="app-option__image mb-4"
          src="./assets/images/qr.png"
          alt="qr-code-image"
        />
        <div class="text-center text-gray-600 text-small mb-4"> Scan QR Easy </div>
        <div class="mat-h2">SCANNER</div>
      </div>
    </button>
  </div>
</div>
